import { GoalAnalyticsMetricKey } from '../types';

export const METRIC_SECTIONS_ORDER: [GoalAnalyticsMetricKey, string][] = [
  [GoalAnalyticsMetricKey.TOTAL_GOAL_CONVERSIONS, 'goalPerformance.totalGoalConversions'],
  [
    GoalAnalyticsMetricKey.TOTAL_GOAL_CONVERSIONS_BY_TOTAL_MESSAGES_SENT,
    'goalPerformance.goalConversionRate',
  ],
  [GoalAnalyticsMetricKey.UNIQUE_GOAL_CONVERSIONS, 'goalPerformance.uniqueGoalConversions'],
  [
    GoalAnalyticsMetricKey.UNIQUE_GOAL_CONVERSIONS_BY_UNIQUE_MESSAGES_SENT,
    'goalPerformance.uniqueConversionRate',
  ],
];

export const REVENUE_SECTIONS: [GoalAnalyticsMetricKey, string][] = [
  [GoalAnalyticsMetricKey.REVENUE, 'goalPerformance.totalRevenue'],
];
